import {clearRechargeGiftCooldown} from './recharge-gift-cooldown';
import {clearRechargeGiftPopupCount} from './recharge-gift-popup-count';

export const clearRechargeGiftAccountStorage = () => {
  clearRechargeGiftCooldown();
  clearRechargeGiftPopupCount();
};
